import { render, staticRenderFns } from "./AccountContact.vue?vue&type=template&id=7c583fe4&"
import script from "./AccountContact.vue?vue&type=script&lang=js&"
export * from "./AccountContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports